import Typography from '@mui/material/Typography';


export default function InfoMicroText() {
  
  return (
<div>
    
<Typography variant="subtitle1">
    
Your mouth microbiome is made up of a wide variety of microbes, including bacteria, fungi, and viruses. These organisms influence how you digest food,
regulate inflammation, and maintain immune balance. In this report, we break down your results into two main categories:  
<Typography component="span" fontWeight={600}> Composition</Typography> and <Typography component="span" fontWeight={600}> Health Indicators. </Typography>
<br /><br />
All values are compared to reference ranges from healthy populations. If a result is <Typography component="span" fontWeight={600}>outside the expected range</Typography>, 
it's marked in <Typography component="span" fontWeight={600}>red</Typography> — this doesn't mean
something is wrong, but it may deserve attention. Values within the healthy range are marked <Typography component="span" fontWeight={600}>green</Typography>.
<br /><br /> 
<Typography component="span" fontWeight={600}>Composition:</Typography>
<br /><br /> 
This part describes the overall structure and balance of your microbiome. 
We look at the diversity and richness of the microbial community, which can reflect how resilient and stable your gut environment is.
<br /><br />

<ul style={{ paddingLeft: '20px' }}>

<li>
<Typography component="span" fontWeight={600}>Enterotype:</Typography>
<br /><br />
Your gut microbiome can be classified into general patterns, or “types,” based on which bacteria are most dominant. 
A Bacteroides-dominated enterotype is common in people with a Western-style diet. Other types, like Prevotella or Ruminococcus, 
may reflect differences in fiber metabolism and immune activity.
<br /><br />
</li>
<li>
<Typography component="span" fontWeight={600}>Species Diversity:</Typography>
<br /><br />
Measures how many different microbes are present and how evenly they are distributed. 
A higher diversity often suggests a more adaptable and healthy gut ecosystem. Reference range: 3.5 - 5.5
<br /><br />
</li>

<li>
<Typography component="span" fontWeight={600}> Species Richness:</Typography>
<br /><br />
 Refers to the total number of different microbial species found in your sample. 
 Richness alone doesn't tell the full story but adds context to diversity. Reference range: 200 - 600 species
 <br /><br />
</li>

<li>
<Typography component="span" fontWeight={600}>  Species Evenness:</Typography>
<br /><br />
Shows how equally the different microbial species are represented in your gut. 
High evenness suggests a more balanced ecosystem without dominant overgrowths. Reference range: 0.6 - 0.9
 <br /><br />
</li>

<li>
<Typography component="span" fontWeight={600}>  Taxonomic Levels (Phyla, Genera, Species):</Typography>
<br /><br />clear


<Typography component="span" fontWeight={600}>What you see:</Typography> The microbes contributing to each SCFA type and their relative abundance.<br />
<Typography component="span" fontWeight={600}>Why it matters:</Typography> Low SCFA-producing bacteria may be linked to higher inflammation, digestive issues, or poor fiber intake.<br />
<br />
</li>

</ul>



<Typography component="span" fontWeight={600}>Additional Microbial Health Signals</Typography> <br /><br />
These indicators provide deeper insight into your microbial balance.<br />

<ul style={{ paddingLeft: '20px' }}>

<li>
<Typography component="span" fontWeight={600}>Level of Faecalibacterium prausnitzii:</Typography> <br /><br />
A highly beneficial bacterium known for its anti-inflammatory effects and strong butyrate production (Ref value: above 5).
<br /><br />
<Typography component="span" fontWeight={600}>Why it matters:</Typography>  Low levels have been associated with inflammatory bowel conditions and reduced gut resilience.​
<br /><br />
</li>

<li>
<Typography component="span" fontWeight={600}>F/B Ratio (Firmicutes/Bacteroidetes):</Typography> <br /><br />
This ratio reflects the balance between two dominant gut phyla (Ref range: - 0.2 to 0.4).<br />
<Typography component="span" fontWeight={600}>Why it matters:</Typography>  While interpretation is still evolving, imbalances may correlate with metabolic changes, inflammation, or dietary patterns.
<br /><br />
</li>

<li>
<Typography component="span" fontWeight={600}>Opportunistic Pathogens:</Typography> <br /><br />
These microbes are not inherently harmful but can become problematic in higher amounts or when the gut is out of balance. We flag their presence when
they appear above expected thresholds.<br /><br />

<ul style={{ paddingLeft: '20px' }}>
<li>
Pathobionts: <br />
Microbes that may trigger inflammation under certain conditions. Presence and abundance are shown only if detected.<br /><br />
</li>
<li>
Proteobacteria: <br />
An increase in Proteobacteria is often a marker of dysbiosis or microbial stress. Includes bacteria like Escherichia coli or Salmonella in some cases.<br /><br />
</li>
<li>
Fusobacteria:<br />
This phylum is usually found in small amounts or not at all in healthy guts (Ref value: below 0.1).<br />
<Typography component="span" fontWeight={600}>Why it matters:</Typography> Elevated levels may correlate with inflammation or shifts in gut ecology.
</li>

</ul>
</li>

</ul>


</Typography>    
</div>

   )
}